import { faArrowDown, faArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, SxProps } from '@modusign/design-system';

interface OrderIndicatorProps extends SxProps {
  order: 'asc' | 'desc' | null;
}

export default function OrderIndicator({ order, sx }: OrderIndicatorProps) {
  if (!order) {
    return null;
  }

  return (
    <Box
      as={FontAwesomeIcon}
      color="textNeutralVeryLight"
      fontSize="11px"
      icon={order === 'asc' ? faArrowUp : faArrowDown}
      style={{ fontSize: '11px', marginLeft: '4px' }}
      sx={sx}
    />
  );
}
